import styled, { DefaultTheme } from 'styled-components/native'
import { ListItem as RNEListItem } from 'react-native-elements'

interface Props {
  theme: DefaultTheme
  bottomDivider?: boolean
  containerStyle?: object
  selected?: boolean
}

export const StyledListItem = styled(RNEListItem).attrs(
  ({ bottomDivider = true, containerStyle = {}, theme, selected }: Props) => {
    const bottomDividerStyle = bottomDivider
      ? {
          borderBottomWidth: 1,
          borderBottomColor: theme.colors.elementsBorder,
        }
      : {}
    return {
      underlayColor: theme.colors.background,
      containerStyle: {
        backgroundColor: selected ? theme.colors.lightGray : theme.colors.elementsBg,
        paddingHorizontal: theme.metrics.baseMargin * 1.5,
        ...bottomDividerStyle,
        ...containerStyle,
      },
    }
  }
)<{ selected?: boolean }>``

export const StyledListItemContainer = styled(RNEListItem.Content)`
  flex: 1;
  row-gap: ${({ theme: { metrics } }) => metrics.baseMargin / 8}px;
`
